import { ReactNode } from 'react';
import { VestingCardStyles } from '@dealstack/frontend/shared/components/VestingCard/VestingCard.styles.tsx';
import { Flex, MantineColor, MantineSize, StyleProp, Text, Tooltip } from '@mantine/core';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';

interface Props {
	title: string;
	icon?: ReactNode;
	titleSize?: MantineSize | number;
	titleWeight?: number;
	titleColor?: StyleProp<MantineColor>;
	children?: ReactNode;
	expandable?: boolean;
	expanded?: boolean;
	onExpandChange?: (expanded: boolean) => void;
	expandDisabled?: boolean;
	expandDisabledTooltip?: string;
}

export const VestingCard = ({
	title,
	icon,
	children,
	titleSize = 'sm',
	titleWeight = 700,
	titleColor = 'dark.8',
	expandable = false,
	expanded = true,
	onExpandChange,
	expandDisabled = false,
	expandDisabledTooltip,
}: Props) => {
	const switchEl = (
		<AdvancedSwitch
			selectedValue={expanded}
			onChange={(event) => onExpandChange?.(!!event)}
			size="m"
			disabled={expandDisabled}
		/>
	);

	return (
		<VestingCardStyles>
			<Flex justify="space-between" align="center">
				<Flex gap="0.5rem" className={`title ${!expanded ? 'disabled' : ''}`}>
					{icon}

					<Text fz={titleSize} fw={titleWeight} c={titleColor}>
						{title}
					</Text>
				</Flex>

				{expandable &&
					(expandDisabled && expandDisabledTooltip ? (
						<Tooltip label={expandDisabledTooltip} withArrow>
							<div>{switchEl}</div>
						</Tooltip>
					) : (
						switchEl
					))}
			</Flex>

			{expanded && children}
		</VestingCardStyles>
	);
};
